import fetch from './api-base'
export default {
  getCode: params => fetch({ method: 'GET', url: '/identity/v1/Login/smscode', params }),
  login: data => fetch({ method: 'POST', url: '/identity/v1/Login/smscode', data }),
  refresh: data => fetch({ method: 'POST', url: `/identity/v1/Login/refresh`, data }),
  getURLs: (token) => fetch({ method: 'GET',headers: {'Authorization':'Bearer ' +token }, url: '/authorization/v1/Permission/platformauthorization',}),
}
